<template>
  <div class="main">
    <!-- loading -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="loading"
      :element-loading-text="loadingtext"
    ></div>
    <heads></heads>
    <banners></banners>
    <!-- <islogin /> -->
    <div class="content">
      <div class="cons">
        <!-- 生成标题0001 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">生成文本</div>
            <el-form-item label="关键词">
              <el-input v-model="form.bt" placeholder="请输入标题或者关键词" />
            </el-form-item>
            <el-form-item label="作者身份">
              <el-input v-model="form2.zz" placeholder="请输入作者" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit11()"
                >生成文本11</el-button
              >
              <!-- <el-button type="danger" @click="onSubmityjsc()"
                >一键生成（等待时长约5分钟，请勿关闭页面）</el-button
              > -->
            </div>
            <el-form-item label="生成的文本">
              <el-input
                autosize
                type="textarea"
                v-model="form.writerorg2"
                placeholder="请输入文本"
              />
            </el-form-item>
            <div class="custom-block">生成标题</div>
            <el-form-item label="hs">
              <el-input
                autosize
                type="textarea"
                v-model="form.writerorg"
                placeholder="请输入文本"
              />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit12()"
                >生成标题12</el-button
              >
            </div>
            <el-form-item label="备选标题">
              <el-input autosize type="textarea" v-model="form.resobj" />
            </el-form-item>
            <el-form-item label="选定标题">
              <el-input v-model="form2.bt" placeholder="请输入标题" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit121()"
                >生成参考文献</el-button
              >
            </div>
            <div class="custom-block">
              <div>参考文献</div>
            </div>
            <div v-for="(item, key) in form.ckwx" :key="key">{{ item }}</div>
          </el-form>
        </div>

        <!-- 第二步 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">生成大纲</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form2.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit21()"
                >生成大纲21</el-button
              >
            </div>
            <el-form-item label="大纲">
              <el-input
               autosize
                type="textarea"
                v-model="tigang"
                placeholder="请输入文本"
              />
            </el-form-item>
          </el-form>
        </div>
        <!-- 第一部分（1500字） -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">第一部分（1500字）</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form01.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit001()"
                >生成第一部分</el-button
              >
            </div>
            <el-form-item label="第一部分">
              <el-input autosize type="textarea" v-model="reswenti1" />
            </el-form-item>
          </el-form>
        </div>
        <!-- 第二部分（2500字） -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">第二部分（2500字）</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form02.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit002()"
                >生成第二部分</el-button
              >
            </div>
            <el-form-item label="第二部分">
              <el-input autosize type="textarea" v-model="reswenti2" />
            </el-form-item>
          </el-form>
        </div>
        <!-- 第三部分（2500字） -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">第三部分（2500字）</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form03.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit003()"
                >第三部分（2500字）</el-button
              >
            </div>
            <el-form-item label="第三部分">
              <el-input autosize type="textarea" v-model="reswenti3" />
            </el-form-item>
          </el-form>
        </div>
        <!-- 第四部分（1500字） -->
        <div class="cons-form">
          <el-form :model="form" label-width="120px">
            <div class="custom-block">第四部分（1500字）</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form04.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit004()"
                >第四部分（1500字）</el-button
              >
            </div>
            <el-form-item label="第四部分">
              <el-input autosize type="textarea" v-model="reswenti4" />
            </el-form-item>
          </el-form>
        </div>

        <!-- 结束语部分（1000字）-->
        <div class="cons-form">
          <el-form :model="form" label-width="120px">
            <div class="custom-block">结束语部分（1000字）</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form06.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit006()"
                >生成结束语</el-button
              >
            </div>
            <el-form-item label="结束语">
              <el-input autosize type="textarea" v-model="reswenti6" />
            </el-form-item>
          </el-form>
        </div>

        <!-- 摘要关键词（400字）-->
        <div class="cons-form">
          <el-form :model="form" label-width="120px">
            <div class="custom-block">摘要关键词（400字）</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form08.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit008()">生成摘要关键词</el-button>
            </div>
            <el-form-item label="摘要关键词">
              <el-input autosize type="textarea" v-model="reswenti8" />
            </el-form-item>
          </el-form>
        </div>

        <!-- 论文 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">论文全文</div>
            <el-form-item label="全文">
              <el-input autosize type="textarea" v-model="reslunwen" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref, inject, getCurrentInstance } from "vue";
import "echarts-wordcloud";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();

const baseurls = "http://server-1:8055";
let loadingtext = ref("系统分析中，请等待...");
// 提纲
let tigang = ref("");
// 引言
let yinyan = ref("");
let cankaowenxian = ref("参考文献：\n");
// 每个问题的结果
let reswenti1 = ref("");
let reswenti2 = ref("");
let reswenti3 = ref("");
let reswenti4 = ref("");

let reswenti6 = ref("");
let reswenti8 = ref("");
// 全文
let reslunwen = ref("");
// loading
let loading = ref(false);
let resobj = ref("");
let form = reactive({
  bt: "",
  ckwx: [],
  writerorg: `学术论文“论文标题“选择要求有一定的“创新性“、”实用性“和”科学性“等要求。假如你是一名顶级学者，请围绕 “@标题@”的中心内容意思，生成十篇题目供参考，每个论文标题只写一句话。中间不能出现符号，又如“ XXX”，输出格式为：
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX．
请注意用Markdown格式输出, 以下是关键词：`,
  writerorg2: "",
  resobj: "",
});
let form2 = reactive({
  bt: "",
  zz: "顶级学者",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”的中心内容意思，生成一篇论文大纲，请注意用阿拉伯数字编号。
如“0；1，1.1，1.2，1.3，1.4；2，2.1，2.2，2.3，2.4；3，3.1，3.2，3.3，3.4；4，4.1，4.2，4.3，4.4；结束语”的示例。
要求论文提纲各级标题有新颖性，每个标题只写一句话。
论文大纲围绕“论文标题“分为六部分，不写文献综述，不写实验案例，如示例只写到二级标题，每一级都要按示例写满，不要多写也不要少写。
请根据以下关键词并进行组合，并用MARKDOWN格式输出。如 (引言部分)（第一部分）（第二部分）（第三部分）（第四部分）（结束语部分），不要出现失误。输出格式为： 
（引言部分）
0 引言（围绕论文标题进行总结性开题，写3层意思一段话，总计八百汉字800汉字左右）。
（第一部分）
1 XXX
1.1	XXX 
1.2	XXXX 
1.3	XXXX 
1.4   XXXX
（第二部分）
2 XXX
2.1	XXX 
2.2	XXX 
2.3	XXX
2.4   XXX
（第三部分）
3 XXX
3.1	XXX 
3.2	XXX 
3.3	XXX 
3.4   XXX
（第四部分）
4 XXX 
4.1	XXX 
4.2	XXXX 
4.3	XXXX 
4.4   XXXX
（结束语部分）
结束语（围绕论文标题的大纲进行总结性阐述，约五百个汉字（500个汉字）。`,
  writerorg2: "",
});
let form01 = reactive({
  writerorg: `请根据下面提交的大纲的中“第一部分“或者“1.X“的内容进行写作，不要展开其他部分内容。
先展开只要重要的2句过渡性的语言；然后每一个小节展开详细描述五百字（500字），但不要分点描述，整合起来写。但请还要注意每一标题前面的阿拉伯数字序号都要原样保留，结果输出中不要出现论文标题。不要出现“我们”等第一人称字样，少用“的”等虚词，在字数满足一千五百字（1500字）的基础上，尽量少用虚词写精炼一点。要注意标题前面的序号都要保留。
用学术论文的口气来调整，不用转折词。示例：以下转折词“因此、以及、除了、同时、况且、而且、何况、乃至、还有、并且、再加上、此外、不仅如此、除此之外、不只、另外、理所当然、至于、再说特别是、尤其、甚至、另外、另一方面、相对地、同时、以来、以后、以前、好比、如同、似乎、等于、像、具体来说、例如、像、如、一般、比方、比如、也就是说、其实、原本、换句话说、讲白了、换言之、总而言之、总的说来、综合而言、简言之、顺带一提、则、乃、就**而言、而、于是、说到、如果、如果不是、假设、若是、假使、倘若、要是、譬如、只要……就能……、在……的情况下、根据、或者、抑或、非……即……，不是……就是……、原来、因为、由于、这就是为什么、所谓、理由是、原因是、基于、因此、所以、是故、以致、以便、至乃、致使、于是、借由、借着、为了、为此、向着、着眼于、但是、然而、而、偏偏、只是、不过、 至于、致、不料、岂知、可是、虽然、虽说如此、相反地、当然、确实、没错、虽然、固然、尽管、纵然、即使、纵使、纵令、纵然、至少、那么、接下来、对了、不如、不及、综上所述、与其……不如”等转折词不要出现。
请记住，不要展开，只写“指定”部分的相关内容1500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第一部分“或者“1.X“的内容。要求论文提纲各级标题有新颖性，二级标题中要有符号，比如 4.1 “XX，XXX”、 4.2“XX，XXX”、 4.3 “XX，XXX”。
大纲如下：`,
});
let form02 = reactive({
  writerorg: `请根据下面提交的大纲的中“第二部分“或者“2.X“的内容进行写作，不要展开其他部分内容。
在2 和2.1之间先展开只要重要的3句过渡性的语言；然后每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。但请还要注意每一标题前面的阿拉伯数字序号都要原样保留。不要出现“我们”等第一人称字样，少用“的”等虚词，在字数满足二千五百字（2500字）的基础上，尽量少用虚词写精炼一点。要注意标题前面的序号都要保留。
用学术论文的口气来调整，不用转折词。示例：以下转折词“因此、以及、除了、同时、况且、而且、何况、乃至、还有、并且、再加上、此外、不仅如此、除此之外、不只、另外、理所当然、至于、再说特别是、尤其、甚至、另外、另一方面、相对地、同时、以来、以后、以前、好比、如同、似乎、等于、像、具体来说、例如、像、如、一般、比方、比如、也就是说、其实、原本、换句话说、讲白了、换言之、总而言之、总的说来、综合而言、简言之、顺带一提、则、乃、就**而言、而、于是、说到、如果、如果不是、假设、若是、假使、倘若、要是、譬如、只要……就能……、在……的情况下、根据、或者、抑或、非……即……，不是……就是……、原来、因为、由于、这就是为什么、所谓、理由是、原因是、基于、因此、所以、是故、以致、以便、至乃、致使、于是、借由、借着、为了、为此、向着、着眼于、但是、然而、而、偏偏、只是、不过、 至于、致、不料、岂知、可是、虽然、虽说如此、相反地、当然、确实、没错、虽然、固然、尽管、纵然、即使、纵使、纵令、纵然、至少、那么、接下来、对了、不如、不及、综上所述、与其……不如”等转折词不要出现。
请记住，不要展开，只写“指定”部分的相关内容2500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第二部分“或者“2.X“的内容，而不要输出标题。
大纲如下：`,
});
let form03 = reactive({
  writerorg: `请根据下面提交的大纲的中“第三部分”或者“3.X“的内容进行写作，不要展开其他部分内容。
在3 和3.1之间先展开只要重要的3句过渡性的语言作为一段；然后每一个小节一个小标题，每一节展开详细描述八百字（800字），不要分点描述而是要整合起来写。请还要注意每一标题前面的阿拉伯数字序号都要原样保留。不要出现“我们”等第一人称字样，少用“的”等虚词，在字数满足二千五百字（2500字）的基础上，尽量少用虚词写精炼一点。要注意标题前面的序号都要保留。
用学术论文的口气来调整，不用转折词。示例：以下转折词“因此、以及、除了、同时、况且、而且、何况、乃至、还有、并且、再加上、此外、不仅如此、除此之外、不只、另外、理所当然、至于、再说特别是、尤其、甚至、另外、另一方面、相对地、同时、以来、以后、以前、好比、如同、似乎、等于、像、具体来说、例如、像、如、一般、比方、比如、也就是说、其实、原本、换句话说、讲白了、换言之、总而言之、总的说来、综合而言、简言之、顺带一提、则、乃、就**而言、而、于是、说到、如果、如果不是、假设、若是、假使、倘若、要是、譬如、只要……就能……、在……的情况下、根据、或者、抑或、非……即……，不是……就是……、原来、因为、由于、这就是为什么、所谓、理由是、原因是、基于、因此、所以、是故、以致、以便、至乃、致使、于是、借由、借着、为了、为此、向着、着眼于、但是、然而、而、偏偏、只是、不过、 至于、致、不料、岂知、可是、虽然、虽说如此、相反地、当然、确实、没错、虽然、固然、尽管、纵然、即使、纵使、纵令、纵然、至少、那么、接下来、对了、不如、不及、综上所述、与其……不如”等转折词不要出现。
请记住，不要展开，只写“指定”部分的相关内容，阿拉伯数字序号都要原样保留。不要输出标题。
大纲如下：`,
});
let form04 = reactive({
  writerorg: `请根据下面提交的大纲的中“第四部分“的部分“4.X“内容进行写作，不要展开其他部分的内容。
在4 和4.1之间先展开只要重要的3句过渡性的语言；然后每一个小节一个小标题，每一节展开详细描述五百字（500字），但不要分点描述，整合起来写。但请还要注意每一标题前面的阿拉伯数字序号都要原样保留。不要出现“我们”等第一人称字样，少用“的”等虚词，在字数满足一千五百字（1500字）的基础上，尽量少用虚词写精炼一点。要注意标题前面的序号都要保留。
用学术论文的口气来调整，不用转折词。示例：以下转折词“因此、以及、除了、同时、况且、而且、何况、乃至、还有、并且、再加上、此外、不仅如此、除此之外、不只、另外、理所当然、至于、再说特别是、尤其、甚至、另外、另一方面、相对地、同时、以来、以后、以前、好比、如同、似乎、等于、像、具体来说、例如、像、如、一般、比方、比如、也就是说、其实、原本、换句话说、讲白了、换言之、总而言之、总的说来、综合而言、简言之、顺带一提、则、乃、就**而言、而、于是、说到、如果、如果不是、假设、若是、假使、倘若、要是、譬如、只要……就能……、在……的情况下、根据、或者、抑或、非……即……，不是……就是……、原来、因为、由于、这就是为什么、所谓、理由是、原因是、基于、因此、所以、是故、以致、以便、至乃、致使、于是、借由、借着、为了、为此、向着、着眼于、但是、然而、而、偏偏、只是、不过、 至于、致、不料、岂知、可是、虽然、虽说如此、相反地、当然、确实、没错、虽然、固然、尽管、纵然、即使、纵使、纵令、纵然、至少、那么、接下来、对了、不如、不及、综上所述、与其……不如”等转折词不要出现。
请记住，不要展开，只写“指定”部分的相关内容，阿拉伯数字序号都要原样保留。输出时，不要输出标题，输入出格式出下：
4  XXX
4.1XXX
4.2XXX
4.3XXX
总之XXX
大纲如下：`,
});

let form06 = reactive({
  writerorg: `接下来，根据最先提交的大纲，回答下面的问题。
请根据下面提交的大纲的中“结束语部分“的内容进行写作，不要展开其他部分的内容。不要分点描述，而是要整合起来写。
但请还要注意每一标题前面的阿拉伯数字序号都要原样保留。不要出现“我们”等第一人称字样，少用“的”等虚词，在字数满足一千字（1000字）的基础上，尽量少用虚词写精炼一点。要注意标题前面的序号都要保留。
用学术论文的口气来调整，不用转折词。示例：以下转折词“因此、以及、除了、同时、况且、而且、何况、乃至、还有、并且、再加上、此外、不仅如此、除此之外、不只、另外、理所当然、至于、再说特别是、尤其、甚至、另外、另一方面、相对地、同时、以来、以后、以前、好比、如同、似乎、等于、像、具体来说、例如、像、如、一般、比方、比如、也就是说、其实、原本、换句话说、讲白了、换言之、总而言之、总的说来、综合而言、简言之、顺带一提、则、乃、就**而言、而、于是、说到、如果、如果不是、假设、若是、假使、倘若、要是、譬如、只要……就能……、在……的情况下、根据、或者、抑或、非……即……，不是……就是……、原来、因为、由于、这就是为什么、所谓、理由是、原因是、基于、因此、所以、是故、以致、以便、至乃、致使、于是、借由、借着、为了、为此、向着、着眼于、但是、然而、而、偏偏、只是、不过、 至于、致、不料、岂知、可是、虽然、虽说如此、相反地、当然、确实、没错、虽然、固然、尽管、纵然、即使、纵使、纵令、纵然、至少、那么、接下来、对了、不如、不及、综上所述、与其……不如”等转折词不要出现。
输出时，不要输出标题，输入出格式出下：
结束语
综上总述，XXX
在以后的工作中，XXX
大纲如下：`,
});

let form08 = reactive({
  writerorg: `根据下面输出的所有内容，写一段论文摘要，四百字，并列出五个关键词。摘要以第三人称，围绕为什么要写这个论文，通过什么方法解决了什么问题，达到了什么效果。不要在摘要中出现重复的词，如本文、笔者等，尽可能少用虚词。
用学术论文的口气来调整，不用转折词。示例：以下转折词“因此、以及、除了、同时、况且、而且、何况、乃至、还有、并且、再加上、此外、不仅如此、除此之外、不只、另外、理所当然、至于、再说特别是、尤其、甚至、另外、另一方面、相对地、同时、以来、以后、以前、好比、如同、似乎、等于、像、具体来说、例如、像、如、一般、比方、比如、也就是说、其实、原本、换句话说、讲白了、换言之、总而言之、总的说来、综合而言、简言之、顺带一提、则、乃、就**而言、而、于是、说到、如果、如果不是、假设、若是、假使、倘若、要是、譬如、只要……就能……、在……的情况下、根据、或者、抑或、非……即……，不是……就是……、原来、因为、由于、这就是为什么、所谓、理由是、原因是、基于、因此、所以、是故、以致、以便、至乃、致使、于是、借由、借着、为了、为此、向着、着眼于、但是、然而、而、偏偏、只是、不过、 至于、致、不料、岂知、可是、虽然、虽说如此、相反地、当然、确实、没错、虽然、固然、尽管、纵然、即使、纵使、纵令、纵然、至少、那么、接下来、对了、不如、不及、综上所述、与其……不如”等转折词不要出现。
格式如下：
摘要：随着XX（直接输出在“摘要：”后面不换行）
关键词：XX；XX
输出内容：`,
});

// 生成标题
const onSubmit11 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetSearchZl", {
    bt: form.bt,
    sentence: "",
    subhs: "",
  })
    .then((res) => {
      loading.value = false;
      form.writerorg2 = res.data;
    })
    .catch((err) => {
      loading.value = false;
    });
};
const onSubmit12 = () => {
  loading.value = true;
  // 替换话术
  let temphs = form.writerorg.replace("@标题@", form.bt);
  post(baseurls + "/api/Kw/GetZlCuts", {
    bt: form.bt,
    sentence: form.writerorg2,
    subhs: temphs,
  })
    .then((res) => {
      form.resobj = res.data.resdata;
      // 获取推荐标题
      onSubmit13(res.data.resdata);
    })
    .catch((err) => {
      loading.value = false;
    });
};
const onSubmit13 = (data) => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetTitleTj", {
    sentence: data,
  })
    .then((res) => {
      loading.value = false;
      form2.bt = res.data.bt[0].title;
    })
    .catch((err) => {
      loading.value = false;
    });
};

// 生成参考文献
const onSubmit121=()=>{
  loading.value = true;
  cankaowenxian.value='参考文献：\n'
  post(baseurls + "/api/Kw/GetCkwxTj", {
    sentence: form2.bt,
  })
    .then((res) => {
      loading.value = false;
      form.ckwx = res.data.list;
      form.ckwx.forEach((e) => {
        cankaowenxian.value += `${e}\n`;
      });
    })
    .catch((err) => {
      loading.value = false;
    });
}

// 生成大纲
const onSubmit21 = () => {
  loading.value = true;
  // 替换话术
  let temphs = form2.writerorg.replace("@标题@", form2.bt);
  form2.writerorg2 = temphs.replace("@身份@", form2.zz);

  post(baseurls + "/api/Kw/GetDgChatAPI", {
    sentence: form2.writerorg2,
  })
    .then((res) => {
      loading.value = false;
      tigang.value = res.data.yw;
      form01.writerorg += res.data.yw;
      yinyan.value = res.data.yy;
    })
    .catch((err) => {
      loading.value = false;
    });
};

// 生成第一部分
const onSubmit001 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form01.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti1.value = res.data;
      form02.writerorg += tigang.value;
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成第二部分
const onSubmit002 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form02.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti2.value = res.data;
      form03.writerorg += tigang.value;
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成第三部分
const onSubmit003 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form03.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti3.value = res.data;
      form04.writerorg += tigang.value;
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成第四部分
const onSubmit004 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form04.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti4.value = res.data;
      form06.writerorg += tigang.value;
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成结束语部分
const onSubmit006 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form06.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti6.value = res.data;
      form08.writerorg += yinyan.value +  reswenti1.value + reswenti2.value + reswenti3.value +reswenti4.value +reswenti6.value + cankaowenxian.value
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成摘要关键词
const onSubmit008 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form08.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti8.value = res.data;

      //生成全文  标题  摘要关键字  引言   正文   参考文献
      reslunwen.value = `
        ${form2.bt}\n
        ${reswenti8.value}\n
        ${yinyan.value}\n
        ${reswenti1.value}\n
        ${reswenti2.value}\n
        ${reswenti3.value}\n
        ${reswenti4.value}\n
        ${reswenti6.value}\n
        ${cankaowenxian.value}
      `;
    })
    .catch((err) => {
      loading.value = false;
    });
};











































</script>

<style scoped>
:deep(.el-form-item__label) {
  background: #f5f7fa;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
}
:deep(.cons-form .el-input__inner) {
  height: 40px;
  font-size: 18px;
}
:deep(.cons-form .el-textarea__inner) {
  min-height: 100px !important;
  font-size: 18px;
}
:deep(.cons-form .el-button) {
  width: auto;
  height: 50px;
  font-size: 18px;
}
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 1200px;
  margin: auto;
  padding: 30px 0;
}
.cons-form {
  width: 100%;
}
.cons-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.cons-subtitle {
  width: 100%;
  padding: 10px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin: auto;
  margin-bottom: 30px;
}
.custom-block {
  padding: 10px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 5px solid #409eff;
  margin: 20px 0 20px 0;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-btn {
  text-align: center;
  margin-bottom: 30px;
}
.cons-title-subtitle {
  color: #999;
  font-size: 14px;
}
.cons-title-subtitle p {
  margin: 0;
  padding: 0;
  text-align: center;
}
.qksx-list-con {
  font-size: 14px;
  padding: 20px 0 0 0;
}
.qksx-list-con:after {
  content: "";
  display: table;
  clear: both;
}
.xsqk-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xsqk-list {
  cursor: pointer;
}
.xsqk-list-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.xsfx,
#echartsyyy {
  width: 1200px;
  height: 600px;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
</style>
